<template>
  <el-dialog
    :title="title"
    :visible.sync="_dialogPriceVisible"
    :close-on-click-modal="false"
    width="800px"
    @close="handleClose"
    center
  >
    <div class="category-dialog">
      <div class="price-date">
        <label class="date-label">上报日期</label>
        <el-date-picker
          v-model="priceDate"
          type="date"
          :disabled="mode == 'detail'"
          placeholder="请选择日期"
          value-format="yyyy-MM-dd"
          class="date-picker"
        />
      </div>
      <div
        v-for="(category, index) in categories"
        :key="category.id"
        class="category-item"
      >
        <div class="category-header" @click="toggleCollapse(index)">
          <span class="category-name">{{ category.categoryName }}</span>
          <i
            :class="
              category.collapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
            "
          />
        </div>

        <el-collapse-transition>
          <div v-show="!category.collapsed" class="subcategory-list">
            <div
              v-for="sub in category.subCategories"
              :key="sub.id"
              class="subcategory-item"
            >
              <span class="subcategory-name">{{ sub.wasteName }}</span>
              <el-input
                v-model.number="sub.price"
                :disabled="mode === 'detail'"
                type="number"
                min="0"
                class="price-input"
              />
              <span class="subcategory-unit">{{ sub.unit }}</span>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>

    <div slot="footer" class="dialog-footer" v-if="mode == 'create'">
      <el-button @click="priceVisible = false">取消</el-button>
      <el-button
        type="primary"
        @click="handleSubmit"
        :disabled="mode === 'detail'"
      >
        提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getCurrentPrice,
  createPrice,
  getVersionReport,
} from '@/API/price/price.js';
import fecha from 'element-ui/src/utils/date';

export default {
  name: 'CategoryPriceDialog',
  components: {},
  props: {
    priceVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    mode: {
      type: String,
      required: true,
      default: 'create',
      validator: (value) => ['create', 'detail'].includes(value),
    },
    currentPriceVersion: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      categories: [],
      title: '', // 标题
      priceDate: '', // 上报日期
    };
  },
  computed: {
    _dialogPriceVisible: {
      get() {
        return this.priceVisible;
      },
      set(val) {
        this.$emit('update:priceVisible', val);
      },
    },
  },
  watch: {
    mode: {
      handler(val) {
        let userInfo = localStorage.getItem('ordinaryUser');
        let enterpriseInfo = JSON.parse(userInfo).userDetail?.enterpriseInfo;
        console.log('userinfo', enterpriseInfo);
        this.title = enterpriseInfo.companyName;
        if (val) {
          if (val == 'detail') {
            getVersionReport(this.currentPriceVersion).then((res) => {
              console.log('55555555555', res);
              if (res.data) {
                this.priceDate = res.data.priceDate;
                if (res.data.categories && res.data.categories.length) {
                  res.data.categories.forEach((item) => {
                    item.collapsed = false;
                  });
                  this.categories = res.data.categories;
                }
              }
            });
          } else if (val == 'create') {
            this.getPrice();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    initCategories(data) {
      this.categories = JSON.parse(JSON.stringify(data)).map((category) => ({
        ...category,
        collapsed: false,
      }));
    },

    toggleCollapse(index) {
      console.log('413523626', 'toggleCollapse');
      this.categories[index].collapsed = !this.categories[index].collapsed;
    },
    //
    getPrice() {
      if (this.mode == 'detail') {
      }
      getCurrentPrice().then((res) => {
        console.log('135236236', res);
        if (res.data && res.data.length) {
          res.data.forEach((item) => {
            item.collapsed = false;
          });
        }
        this.categories = res.data;
      });
    },
    handleSubmit() {
      // 提取需要提交的数据
      let submitData = [];
      if (!this.priceDate) {
        this.$message.warning('请选择上报日期');
        return;
      }
      this.categories.forEach((category) => {
        if (category.subCategories.length) {
          category.subCategories.forEach((p) => {
            if (p.price) {
              submitData.push({
                subcategoryId: p.id,
                price: p.price,
                priceDate: this.priceDate,
              });
            }
          });
        }
      });
      console.log('submitData', submitData, this.priceDate, this.categories);
      let params = {
        requests: submitData,
        priceDate: this.priceDate,
      };
      createPrice(params)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success('上报成功');
            this.$emit('updateRecord');
          } else {
            this.$message.error('上报失败');
          }
        })
        .finally(() => {
          this.$emit('update:priceVisible', false);
        });
    },

    handleClose() {
      this.$emit('update:priceVisible', false);
    },
  },
};
</script>

<style scoped lang="less">
.category-dialog {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 10px;
  .price-date {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;

    .date-label {
      font-size: 14px;
      color: #606266;
      white-space: nowrap;
      font-weight: 500;
    }

    .date-picker {
      width: 220px;

      // 优化输入框内部样式
      ::v-deep .el-input__inner {
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        transition: border-color 0.3s;

        &:hover {
          border-color: #c0c4cc;
        }

        &:focus {
          border-color: #409eff;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
        }
      }

      // 优化日期面板样式
      ::v-deep .el-picker-panel {
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

        .el-date-table td.current:not(.disabled) span {
          background-color: #409eff;
          color: white;
        }
      }
    }
  }
  .category-item {
    margin-bottom: 16px;
    border: 1px solid #ebeef5;
    border-radius: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .category-header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background-color: #f5f7fa;
    cursor: pointer;
    user-select: none;

    &:hover {
      background-color: #f0f2f5;
    }

    .category-name {
      flex: 1;
      font-weight: 500;
    }

    .category-unit {
      margin: 0 12px;
      color: #909399;
    }

    .collapse-icon {
      color: #909399;
      transition: transform 0.3s;
    }
  }

  .subcategory-list {
    padding: 8px 16px;
  }

  .subcategory-item {
    display: flex;
    align-items: center;
    padding: 8px 0;

    &:not(:last-child) {
      border-bottom: 1px dashed #ebeef5;
    }

    .subcategory-name {
      flex: 1;
    }

    .price-input {
      width: 120px;
      margin: 0 12px;
    }

    .subcategory-unit {
      width: 60px;
      color: #909399;
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>